// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

.button-with-status-container {
  display: flex;
}

.status-on-button {
  position: relative;
  bottom: 10px;
  right: 20px;
}

.action-button-admin {
  border-radius: 3px;
  cursor: pointer;
  border: none;
  background: #0d6efd;
  color: white;
  height: 30px;
  padding: 0px 7px;
  font-weight: 600;
  font-size: 0.85em;
  margin-top: 10px;
  transition: 0.2s ease-in-out;
}
.action-button-admin:hover {
  padding-left: 30px;
}
.action-button-admin:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.action-button-reg {
  border-radius: 3px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  cursor: pointer;
  border: none;
  background: #0669B3;
  color: white;
  min-height: 30px;
  transition: 0.1s ease;
  padding: 0px 8px;
  margin: 0 10px;
}
.action-button-reg:hover {
  transform: scale(1.015);
  background: #1786DB;
}
.action-button-reg:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.action-button-small {
  border-radius: 3px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  cursor: pointer;
  border: none;
  background: #0669B3;
  color: white;
  font-size: 0.8rem;
  min-height: 20px;
  transition: 0.1s ease;
  padding: 0px 8px;
}
.action-button-small:hover {
  transform: scale(1.015);
  background: #1786DB;
}
.action-button-small:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.action-button-80 {
  border-radius: 3px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  cursor: pointer;
  border: none;
  background: #0669B3;
  color: white;
  min-height: 30px;
  transition: 0.1s ease;
  width: 80px;
  margin: 0 10px;
}
.action-button-80:hover {
  transform: scale(1.015);
  background: #1786DB;
}
.action-button-80:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.action-button-100 {
  border-radius: 3px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  cursor: pointer;
  border: none;
  background: #0669B3;
  color: white;
  min-height: 30px;
  transition: 0.1s ease;
  width: 100px;
  margin: 0 10px;
}
.action-button-100:hover {
  transform: scale(1.015);
  background: #1786DB;
}
.action-button-100:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.action-button-150 {
  border-radius: 3px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  cursor: pointer;
  border: none;
  background: #0669B3;
  color: white;
  min-height: 30px;
  transition: 0.1s ease;
  width: 150px;
  margin: 0 10px;
}
.action-button-150:hover {
  transform: scale(1.015);
  background: #1786DB;
}
.action-button-150:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.action-button-200 {
  border-radius: 3px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  cursor: pointer;
  border: none;
  background: #0669B3;
  color: white;
  min-height: 30px;
  transition: 0.1s ease;
  width: 200px;
  margin: 0 10px;
}
.action-button-200:hover {
  transform: scale(1.015);
  background: #1786DB;
}
.action-button-200:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.ghost-button-reg {
  border-radius: 3px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  cursor: pointer;
  border: 1px solid #0669B3;
  background: white;
  color: #0669B3;
  min-height: 30px;
  transition: 0.1s ease;
  padding: 0px 20px;
  margin: 0 10px;
}
.ghost-button-reg:hover {
  transform: scale(1.015);
  background: #EDEDED;
}
.ghost-button-reg:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.ghost-button-delete {
  border-radius: 3px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  cursor: pointer;
  border: 1px solid #CB321A;
  background: white;
  color: #CB321A;
  min-height: 30px;
  transition: 0.1s ease;
  padding: 0px 20px;
  margin: 0 10px;
}
.ghost-button-delete:hover {
  transform: scale(1.015);
  background: #EDEDED;
}
.ghost-button-delete:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.action-button-delete {
  border-radius: 3px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  cursor: pointer;
  border: none;
  background: #CB321A;
  color: white;
  min-height: 30px;
  transition: 0.1s ease;
  margin: 0 10px;
  padding: 0px 20px;
}
.action-button-delete:hover {
  transform: scale(1.015);
  background: #E2381D;
}
.action-button-delete:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.action-button-delete-100 {
  border-radius: 3px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  cursor: pointer;
  border: none;
  background: #CB321A;
  color: white;
  min-height: 30px;
  transition: 0.1s ease;
  width: 100px;
  margin: 0 10px;
}
.action-button-delete-100:hover {
  transform: scale(1.015);
  background: #E2381D;
}
.action-button-delete-100:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.action-button-small-trashCan {
  border-radius: 3px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  background: #0669B3;
  color: white;
  height: 20px;
  transition: 0.1s ease;
  width: 40px;
  margin: 0 10px;
}
.action-button-small-trashCan:hover {
  transform: scale(1.015);
  background: #1786DB;
}
.action-button-small-trashCan:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.action-button-cancel {
  border-radius: 3px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  cursor: pointer;
  border: none;
  background: #A7A9AC;
  min-height: 30px;
  transition: 0.1s ease;
  padding: 0px 20px;
  margin: 0 10px;
}
.action-button-cancel:hover {
  transform: scale(1.015);
  background: #808080;
}
.action-button-cancel:disabled {
  background-color: rgba(167, 169, 172, 0.5);
  color: #636161;
  cursor: not-allowed;
}

.action-button-reason {
  border-radius: 3px;
  cursor: pointer;
  display: flex;
  align-items: center;
  border: none;
  background: #0669B3;
  color: white;
  height: 30px;
  transition: 0.1s ease;
  padding: 0px 20px;
  margin: 0 10px;
}

.select-button-icon {
  display: flex;
  align-items: center;
}

.grade-button {
  border-radius: 5px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  border: 1px solid #EDF0F1;
  background: white;
  color: #444343;
  min-width: 80px;
  max-width: 96px;
  width: 10%;
  transition: 0.1s ease;
  padding: 4px 8px;
  font-size: 1.1em;
}
.grade-button p.primary {
  margin: 0px;
  font-size: 1.2em;
  font-weight: 500;
}

.grade-button-selected {
  border-radius: 5px;
  background: #0669B3;
  border: 1px solid #EDF0F1;
  color: white;
  max-width: 96px;
  min-width: 80px;
  width: 10%;
  font-size: 1.1em;
  padding: 4px 8px;
  transition: 0.1s ease;
}
.grade-button-selected p.primary {
  margin: 0px;
  font-size: 1.2em;
  font-weight: 500;
}

.tab {
  background-color: #FFFFFF;
  border: 1px solid #D1D3D4;
  border-radius: 10px 10px 0 0;
  color: #636161;
  font-weight: 600;
  margin-bottom: -11px;
  margin-top: 20px;
  padding: 10px;
  z-index: 999;
}

.tab-active {
  background-color: #EDF0F1;
  border-bottom: 1px solid #EDF0F1;
  border-left: 1px solid #D1D3D4;
  border-right: 1px solid #D1D3D4;
  border-top: 1px solid #D1D3D4;
  color: #444343;
  font-weight: 600;
  margin-bottom: -12px;
}

.tab-first {
  margin-left: 10px;
}

@media only screen and (max-width: 1080px) {
  .action-button-reason {
    font-size: 0.7rem;
    padding: 0px 8px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/ActionButton.scss","webpack://./src/styles/global/globalMixins.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;ADJA;;;EAGI,sBAAA;ACOJ;;AAPA;EACE,aAAA;AAUF;;AARA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;AAWF;;AARA;ECTI,kBDUoB;EACtB,eAAA;EACA,YAAA;EACA,mBDTe;ECUf,YAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,4BAAA;AAWF;AATE;EACE,kBAAA;AAWJ;AATE;EACE,YAAA;EACA,mBAAA;AAWJ;;AAPA;EC/BI,kBDgCsB;ECXtB,2CAAA;EDaA,eAAA;EACA,YAAA;EACA,mBDNS;ECOT,YAAA;EACA,gBAAA;EACA,qBAAA;EACA,gBAAA;EACA,cAAA;AAUJ;AARI;EACE,uBAAA;EACA,mBDda;ACwBnB;AARI;EACE,YAAA;EACA,mBAAA;AAUN;;AANE;ECrDE,kBDsDsB;ECjCtB,2CAAA;EDmCA,eAAA;EACA,YAAA;EACA,mBD5BS;EC6BT,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,qBAAA;EACA,gBAAA;AASJ;AAPI;EACE,uBAAA;EACA,mBDpCa;AC6CnB;AAPI;EACE,YAAA;EACA,mBAAA;AASN;;AALA;EC3EI,kBD4EsB;ECvDtB,2CAAA;EDyDA,eAAA;EACA,YAAA;EACA,mBDlDS;ECmDT,YAAA;EACA,gBAAA;EACA,qBAAA;EACA,WAAA;EACA,cAAA;AAQJ;AANI;EACE,uBAAA;EACA,mBD1Da;ACkEnB;AANI;EACE,YAAA;EACA,mBAAA;AAQN;;AALA;EChGI,kBDiGsB;EC5EtB,2CAAA;ED8EA,eAAA;EACA,YAAA;EACA,mBDvES;ECwET,YAAA;EACA,gBAAA;EACA,qBAAA;EACA,YAAA;EACA,cAAA;AAQJ;AANI;EACE,uBAAA;EACA,mBD/Ea;ACuFnB;AANI;EACE,YAAA;EACA,mBAAA;AAQN;;AALE;ECrHE,kBDsHsB;ECjGtB,2CAAA;EDmGA,eAAA;EACA,YAAA;EACA,mBD5FS;EC6FT,YAAA;EACA,gBAAA;EACA,qBAAA;EACA,YAAA;EACA,cAAA;AAQJ;AANI;EACE,uBAAA;EACA,mBDpGa;AC4GnB;AANI;EACE,YAAA;EACA,mBAAA;AAQN;;AALE;EC1IE,kBD2IsB;ECtHtB,2CAAA;EDwHA,eAAA;EACA,YAAA;EACA,mBDjHS;ECkHT,YAAA;EACA,gBAAA;EACA,qBAAA;EACA,YAAA;EACA,cAAA;AAQJ;AANI;EACE,uBAAA;EACA,mBDzHa;ACiInB;AANI;EACE,YAAA;EACA,mBAAA;AAQN;;AAJE;EChKE,kBDiKsB;EC5ItB,2CAAA;ED8IA,eAAA;EACA,yBAAA;EACA,iBAAA;EACA,cDxIS;ECyIT,gBAAA;EACA,qBAAA;EACA,iBAAA;EACA,cAAA;AAOJ;AALI;EACE,uBAAA;EACA,mBDjKE;ACwKR;AALI;EACE,YAAA;EACA,mBAAA;AAON;;AAHE;ECtLE,kBDuLsB;EClKtB,2CAAA;EDoKA,eAAA;EACA,yBAAA;EACA,iBAAA;EACA,cD7KE;EC8KF,gBAAA;EACA,qBAAA;EACA,iBAAA;EACA,cAAA;AAMJ;AAJI;EACE,uBAAA;EACA,mBDvLE;AC6LR;AAJI;EACE,YAAA;EACA,mBAAA;AAMN;;AAFE;EC5ME,kBD6MsB;ECxLtB,2CAAA;ED0LA,eAAA;EACA,YAAA;EACA,mBDlME;ECmMF,YAAA;EACA,gBAAA;EACA,qBAAA;EACA,cAAA;EACA,iBAAA;AAKJ;AAHI;EACE,uBAAA;EACA,mBD1MM;AC+MZ;AAHI;EACE,YAAA;EACA,mBAAA;AAKN;;AADE;EClOE,kBDmOsB;EC9MtB,2CAAA;EDgNA,eAAA;EACA,YAAA;EACA,mBDxNE;ECyNF,YAAA;EACA,gBAAA;EACA,qBAAA;EACA,YAAA;EACA,cAAA;AAIJ;AAFI;EACE,uBAAA;EACA,mBDhOM;ACoOZ;AAFI;EACE,YAAA;EACA,mBAAA;AAIN;;AADE;ECvPE,kBDwPsB;ECnOtB,2CAAA;EDqOA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,mBDjOS;ECkOT,YAAA;EACA,YAAA;EACA,qBAAA;EACA,WAAA;EACA,cAAA;AAIJ;AAFI;EACE,uBAAA;EACA,mBDzOa;AC6OnB;AAFI;EACE,YAAA;EACA,mBAAA;AAIN;;AAAE;EChRE,kBDiRsB;EC5PtB,2CAAA;ED8PA,eAAA;EACA,YAAA;EACA,mBD5PI;EC6PJ,gBAAA;EACA,qBAAA;EACA,iBAAA;EACA,cAAA;AAGJ;AADI;EACE,uBAAA;EACA,mBDnQE;ACsQR;AADI;EACE,0CAAA;EACA,cDrQE;ECsQF,mBAAA;AAGN;;AACE;ECtSE,kBDuSsB;EACtB,eAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,mBD9QS;EC+QT,YAAA;EACA,YAAA;EACA,qBAAA;EACA,iBAAA;EACA,cAAA;AAEJ;;AAAE;EACE,aAAA;EACA,mBAAA;AAGJ;;AAAE;ECxTE,kBADyB;EAsBzB,2CAAA;EDsSA,yBAAA;EACA,iBAAA;EACA,cDhSK;ECiSL,eAAA;EACA,eAAA;EACA,UAAA;EACA,qBAAA;EACA,gBAAA;EACA,gBAAA;AAGJ;AADI;EACI,WAAA;EACA,gBAAA;EACA,gBAAA;AAGR;;AACA;EC5UI,kBADyB;ED+U3B,mBDhTW;ECiTX,yBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,qBAAA;AAEF;AAAE;EACI,WAAA;EACA,gBAAA;EACA,gBAAA;AAEN;;AAEA;EACI,yBAAA;EACA,yBAAA;EACA,4BAAA;EACA,cDvUI;ECwUJ,gBAAA;EACA,oBAAA;EACA,gBAAA;EACA,aAAA;EACA,YAAA;AACJ;;AACA;EACI,yBDpVI;ECqVJ,gCAAA;EACA,8BAAA;EACA,+BAAA;EACA,6BAAA;EACA,cDnVK;ECoVL,gBAAA;EACA,oBAAA;AAEJ;;AAAA;EACI,iBAAA;AAGJ;;AAAA;EACI;IACI,iBAAA;IACA,gBAAA;EAGN;AACF","sourcesContent":["*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n// EPR colors\n// $dashboard-blue: #007bff; this color does not pass Accessibility. Updated version below.\n$dashboard-blue: #0d6efd;\n$dk-blue-toolbar: #19608f;\n$dk-blue: #0A4064;\n$lt-blue: #7DB7CC;\n$pale-blue: #c0def0;\n$information: #00AEEF;\n$information-hover: #02BFFF;\n$DCSD-logo-green: #84ae30;\n$text: #414042;\n$white: #EDEDED;\n$shadow: #525151;\n$red: #CB321A;\n$red-hover: #E2381D;\n$green: #C7CC68;\n\n$highlight: #FDF9D0;\n$important: #FEBF31;\n$lt-important: #FED883;\n$lt-highlight: #FAFAD2;\n$grey0: #EDF0F1;\n$grey1: #D1D3D4;\n$grey2: #A7A9AC;\n$grey3: #808080;\n$grey3a: #707070;\n$grey4: #636161;\n$grey4a: #444343;\n$pearl-blue: #0669B3;\n$pearl-blue-hover: #1786DB;\n$lt-pearl-blue: #63AEDE;\n$lt-pearl-blue-hover: #4589B3;\n\n$timeline-arrow-1: #718355;\n$timeline-arrow-2: #87986a;\n$timeline-arrow-3: #97a97c;\n$timeline-arrow-4: #b5c99a;\n$timeline-arrow-5: #cfe1b9;\n\n$permission-blue: #ADD8E6;\n$permission-green:#90EE90;\n$permission-orange: #FFA07A;\n","@import \"../styles/global/Colors\";\n@import \"../styles/global/globalMixins\";\n\n.button-with-status-container {\n  display: flex\n}\n.status-on-button {\n  position: relative;\n  bottom: 10px;\n  right: 20px\n}\n\n.action-button-admin {\n  @include borderRadius(3px);\n  cursor: pointer;\n  border: none;\n  background: $dashboard-blue;\n  color: white;\n  height: 30px;\n  padding: 0px 7px;\n  font-weight: 600;\n  font-size: .85em;\n  margin-top: 10px;\n  transition: 0.2s ease-in-out;\n\n  &:hover {\n    padding-left: 30px;\n  }\n  &:disabled {\n    opacity: .5;\n    cursor: not-allowed;\n  }\n};\n\n.action-button-reg {\n    @include borderRadius(3px);\n    @include shadow();\n    cursor: pointer;\n    border: none;\n    background: $pearl-blue;\n    color: white;\n    min-height: 30px;\n    transition: 0.1s ease;\n    padding: 0px 8px;\n    margin: 0 10px;\n\n    &:hover {\n      transform: scale(1.015);\n      background: $pearl-blue-hover;\n    }\n    &:disabled {\n      opacity: .5;\n      cursor: not-allowed;\n    }\n  };\n\n  .action-button-small {\n    @include borderRadius(3px);\n    @include shadow();\n    cursor: pointer;\n    border: none;\n    background: $pearl-blue;\n    color: white;\n    font-size: 0.8rem;\n    min-height: 20px;\n    transition: 0.1s ease;\n    padding: 0px 8px;\n\n    &:hover {\n      transform: scale(1.015);\n      background: $pearl-blue-hover;\n    }\n    &:disabled {\n      opacity: .5;\n      cursor: not-allowed;\n    }\n  };\n\n.action-button-80 {\n    @include borderRadius(3px);\n    @include shadow();\n    cursor: pointer;\n    border: none;\n    background: $pearl-blue;\n    color: white;\n    min-height: 30px;\n    transition: 0.1s ease;\n    width: 80px;\n    margin: 0 10px;\n\n    &:hover {\n      transform: scale(1.015);\n      background: $pearl-blue-hover;\n    }\n    &:disabled {\n      opacity: .5;\n      cursor: not-allowed;\n    }\n  };\n.action-button-100 {\n    @include borderRadius(3px);\n    @include shadow();\n    cursor: pointer;\n    border: none;\n    background: $pearl-blue;\n    color: white;\n    min-height: 30px;\n    transition: 0.1s ease;\n    width: 100px;\n    margin: 0 10px;\n\n    &:hover {\n      transform: scale(1.015);\n      background: $pearl-blue-hover;\n    }\n    &:disabled {\n      opacity: .5;\n      cursor: not-allowed;\n    }\n  };\n  .action-button-150 {\n    @include borderRadius(3px);\n    @include shadow();\n    cursor: pointer;\n    border: none;\n    background: $pearl-blue;\n    color: white;\n    min-height: 30px;\n    transition: 0.1s ease;\n    width: 150px;\n    margin: 0 10px;\n\n    &:hover {\n      transform: scale(1.015);\n      background: $pearl-blue-hover;\n    }\n    &:disabled {\n      opacity: .5;\n      cursor: not-allowed;\n    }\n  };\n  .action-button-200 {\n    @include borderRadius(3px);\n    @include shadow();\n    cursor: pointer;\n    border: none;\n    background: $pearl-blue;\n    color: white;\n    min-height: 30px;\n    transition: 0.1s ease;\n    width: 200px;\n    margin: 0 10px;\n\n    &:hover {\n      transform: scale(1.015);\n      background: $pearl-blue-hover;\n    }\n    &:disabled {\n      opacity: .5;\n      cursor: not-allowed;\n    }\n  };\n\n  .ghost-button-reg {\n    @include borderRadius(3px);\n    @include shadow();\n    cursor: pointer;\n    border: 1px solid $pearl-blue;\n    background: white;\n    color: $pearl-blue;\n    min-height: 30px;\n    transition: 0.1s ease;\n    padding: 0px 20px;\n    margin: 0 10px;\n\n    &:hover {\n      transform: scale(1.015);\n      background: $white;\n    }\n    &:disabled {\n      opacity: .5;\n      cursor: not-allowed;\n    }\n  };\n\n  .ghost-button-delete {\n    @include borderRadius(3px);\n    @include shadow();\n    cursor: pointer;\n    border: 1px solid $red;\n    background: white;\n    color: $red;\n    min-height: 30px;\n    transition: 0.1s ease;\n    padding: 0px 20px;\n    margin: 0 10px;\n\n    &:hover {\n      transform: scale(1.015);\n      background: $white;\n    }\n    &:disabled {\n      opacity: .5;\n      cursor: not-allowed;\n    }\n  };\n\n  .action-button-delete {\n    @include borderRadius(3px);\n    @include shadow();\n    cursor: pointer;\n    border: none;\n    background: $red;\n    color: white;\n    min-height: 30px;\n    transition: 0.1s ease;\n    margin: 0 10px;\n    padding: 0px 20px;\n\n    &:hover {\n      transform: scale(1.015);\n      background: $red-hover;\n    }\n    &:disabled {\n      opacity: .5;\n      cursor: not-allowed;\n    }\n  };\n\n  .action-button-delete-100 {\n    @include borderRadius(3px);\n    @include shadow();\n    cursor: pointer;\n    border: none;\n    background: $red;\n    color: white;\n    min-height: 30px;\n    transition: 0.1s ease;\n    width: 100px;\n    margin: 0 10px;\n\n    &:hover {\n      transform: scale(1.015);\n      background: $red-hover;\n    }\n    &:disabled {\n      opacity: .5;\n      cursor: not-allowed;\n    }\n  };\n  .action-button-small-trashCan {\n    @include borderRadius(3px);\n    @include shadow();\n    cursor: pointer;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border: none;\n    background: $pearl-blue;\n    color: white;\n    height: 20px;\n    transition: 0.1s ease;\n    width: 40px;\n    margin: 0 10px;\n\n    &:hover {\n      transform: scale(1.015);\n      background: $pearl-blue-hover;\n    }\n    &:disabled {\n      opacity: .5;\n      cursor: not-allowed;\n    }\n  };\n\n  .action-button-cancel {\n    @include borderRadius(3px);\n    @include shadow();\n    cursor: pointer;\n    border: none;\n    background: $grey2;\n    min-height: 30px;\n    transition: 0.1s ease;\n    padding: 0px 20px;\n    margin: 0 10px;\n\n    &:hover {\n      transform: scale(1.015);\n      background: $grey3;\n    }\n    &:disabled {\n      background-color: rgba(167, 169, 172, 0.5);\n      color: $grey4;\n      cursor: not-allowed;\n    }\n  };\n\n  .action-button-reason {\n    @include borderRadius(3px);\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    border: none;\n    background: $pearl-blue;\n    color: white;\n    height: 30px;\n    transition: 0.1s ease;\n    padding: 0px 20px;\n    margin: 0 10px;\n  };\n  .select-button-icon {\n    display: flex;\n    align-items: center;\n  }\n\n  .grade-button {\n    @include borderRadius();\n    @include shadow();\n    border: 1px solid $grey0;\n    background: white;\n    color: $grey4a;\n    min-width: 80px;\n    max-width: 96px;\n    width: 10%;\n    transition: 0.1s ease;\n    padding: 4px 8px;\n    font-size: 1.1em;\n\n    p.primary {\n        margin: 0px;\n        font-size: 1.2em;\n        font-weight: 500;\n    }\n}\n\n.grade-button-selected {\n  @include borderRadius();\n  background: $pearl-blue;\n  border: 1px solid $grey0;\n  color: white;\n  max-width: 96px;\n  min-width: 80px;\n  width: 10%;\n  font-size: 1.1em;\n  padding: 4px 8px;\n  transition: 0.1s ease;\n\n  p.primary {\n      margin: 0px;\n      font-size: 1.2em;\n      font-weight: 500;\n  }\n}\n\n.tab {\n    background-color: #FFFFFF;\n    border: 1px solid $grey1;\n    border-radius: 10px 10px 0 0;\n    color: $grey4;\n    font-weight: 600;\n    margin-bottom: -11px;\n    margin-top: 20px;\n    padding: 10px;\n    z-index: 999;\n}\n.tab-active {\n    background-color: $grey0;\n    border-bottom: 1px solid $grey0;;\n    border-left: 1px solid $grey1;\n    border-right: 1px solid $grey1;\n    border-top: 1px solid $grey1;\n    color: $grey4a;\n    font-weight: 600;\n    margin-bottom: -12px;\n}\n.tab-first {\n    margin-left: 10px;\n}\n\n@media only screen and (max-width: 1080px) {\n    .action-button-reason {\n        font-size: 0.7rem;\n        padding: 0px 8px;\n    }\n}\n","@import \"./Colors.scss\";\n\n@mixin borderRadius($radius: 5px) {\n    border-radius: $radius;\n}\n\n@mixin dialogueBold() {\n    font-weight: 600;\n    font-size: .9em;\n}\n\n@mixin input() {\n    border-radius: 5px;\n    font-weight: 400;\n    width: 100%;\n}\n\n@mixin infoRounded($radius) {\n    background: $information;\n    border-bottom-left-radius: $radius;\n    border-bottom-right-radius: $radius;\n}\n\n@mixin shadow() {\n    box-shadow: 0.1rem 0.15rem 0.3rem 0 $shadow;\n}\n@mixin shadowBottom() {\n    box-shadow: 0 0.1rem 0.15rem 0 $shadow;\n}\n@mixin standardInputContainer() {\n    font-weight: 500;\n    font-size: .9rem;\n    margin: 10px 0;\n}\n@mixin standardInput() {\n    @include borderRadius(5px);\n    border: none;\n    border: 1px solid $grey3;\n    padding: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
